import { IAddColumnBody } from '@makyoapp/makyo-sdk/api/Tables'
import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'

export enum ExtendedColumnTypes {
  PageURL = 'page-url',
}

export const COLUMN_TYPES_BG_COLOR: Record<ColumnTypes, string> = {
  [ColumnTypes.Text]: 'bg-fuchsia-200',
  [ColumnTypes.Number]: 'bg-blue-200',
  [ColumnTypes.DateTime]: 'bg-orange-200',
  [ColumnTypes.Boolean]: 'bg-amber-200',
  [ColumnTypes.URL]: 'bg-fuchsia-200',
  [ColumnTypes.Image]: 'bg-lime-200',
  [ColumnTypes.Email]: 'bg-fuchsia-200',
  [ColumnTypes.Phone]: 'bg-blue-200',
  [ColumnTypes.RichText]: 'bg-fuchsia-200',
  [ColumnTypes.RowID]: 'bg-fuchsia-200',
  [ColumnTypes.MultiSelect]: 'bg-teal-200',
  [ColumnTypes.Attachment]: 'bg-lime-200',
  [ColumnTypes.Rating]: 'bg-blue-200',
  [ColumnTypes.Icon]: 'bg-fuchsia-200',
  [ColumnTypes.Address]: 'bg-cyan-200',
  [ColumnTypes.Coordinate]: 'bg-cyan-200',
  [ColumnTypes.Slug]: 'bg-fuchsia-200',
  [ColumnTypes.AISEO]: 'bg-emerald-200',
  [ColumnTypes.AITextProcessing]: 'bg-emerald-200',
  [ColumnTypes.QRCode]: 'bg-lime-200',
  [ColumnTypes.Barcode]: 'bg-lime-200',
  [ColumnTypes.Color]: 'bg-orange-200',
  [ColumnTypes.Connection]: 'bg-indigo-300',
  [ColumnTypes.Formula]: 'bg-purple-300',
  [ColumnTypes.Function]: 'bg-purple-300',
  [ColumnTypes.Emoji]: 'bg-black',
  [ColumnTypes.Lookup]: 'bg-teal-300',
  [ColumnTypes.ImageArray]: 'bg-lime-200',
  [ColumnTypes.Array]: 'bg-teal-200',
  [ColumnTypes.Join]: 'bg-indigo-300',
  [ColumnTypes.Math]: 'bg-blue-200',
  [ColumnTypes.Template]: 'bg-blue-200',
  [ColumnTypes.SingleCell]: 'bg-blue-200',
  [ColumnTypes.SessionID]: 'bg-blue-200',
}

export const AI_COLUMNS: Array<ColumnTypes | ExtendedColumnTypes> = [
  ColumnTypes.AISEO,
  ColumnTypes.AITextProcessing,
  ColumnTypes.Formula,
]

export const MULTI_STEP_COL_TYPES: ColumnTypes[] = [ColumnTypes.Connection]

export const TABLE_ROW_ID = '_id'

export const TABLE_ROW_ID_NAME = 'Row ID'

export const CREATE_COL_DEFAULT: IAddColumnBody = {
  _id: '',
  _Name: 'text',
  _Type: ColumnTypes.Text,
  _Settings: {},
  _Connection: {
    _ForeignColumnIDToShow: '',
    _ForeignColumnID: '',
    _ForeignTableID: '',
    _LocalColumnID: '',
    _MatchMultiple: false,
  },
  _Lookup: {
    _ForeignColumnIDToShow: '',
    _ConnectionColumnID: '',
    _Standard: false,
  },
}
